import { listenForFeatureValue } from "@mirage/service-experimentation";
import { tagged } from "@mirage/service-logging";
import { firstValueFrom } from "rxjs";
import type { Metric } from "web-vitals";

const logger = tagged("web-vitals");

export const registerWebVitalsDatadogReporter = async () => {
  const isEnabled = await firstValueFrom(
    listenForFeatureValue("dash_web_2025_04_11_report_web_vitals"),
  );
  return isEnabled === "ON";
};

export const webVitalsDatadogReporter = async (metric: Metric) => {
  const shouldLogToDatadog = await registerWebVitalsDatadogReporter();
  if (shouldLogToDatadog) {
    logger.info(`${metric.name}: ${metric.value} ${metric.rating}`);
  }
};
